import { CARD_CHECKOUT_ONCE } from "src/components/constant/constant";

// Matches mobile resolveCardCheckoutDuration. allowed is null when the role is unrestricted or prefs haven't loaded,
// so the default is used as is. Otherwise: the longest allowed hours within the default, then ONCE, then the
// shortest allowed hours, else the default.
export const pickCheckoutDuration = (allowed: string[] | null, defaultHours: number): string => {
  if (!allowed?.length) return String(defaultHours);

  const hours = allowed
    .filter((value) => value !== CARD_CHECKOUT_ONCE)
    .map(Number)
    .filter((value) => Number.isFinite(value) && value > 0)
    .sort((a, b) => a - b);
  const withinDefault = hours.filter((value) => value <= defaultHours);

  if (withinDefault.length) return String(withinDefault[withinDefault.length - 1]);
  if (allowed.includes(CARD_CHECKOUT_ONCE)) return CARD_CHECKOUT_ONCE;
  return hours.length ? String(hours[0]) : String(defaultHours);
};
